
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import TransformModel from '../TransformModel';

export default class Model extends TransformModel {

    imageSet = new PropertyDescriptor("", '图片集合', "行为", "imageSet", "#anticon-share_card");

    autoplay = new PropertyDescriptor(true, '自动播放', "行为", "bool", "#anticon-play1");

    autoplaySpeed = new PropertyDescriptor(2000, '速度', "行为", "double", "#anticon-Speed-up", {
        placeholder: '请输入播放速度，单位（ms）',
        description: '播放速度，单位（ms）',
    });

    widthFill = new PropertyDescriptor(true, '宽度铺满', "行为", "bool", "#anticon-fit-width", {
        description: "将图片宽度铺满控件"
    });

    heightFill = new PropertyDescriptor(true, '高度铺满', "行为", "bool", "#anticon-fit-height", {
        description: "将图片高度铺满控件"
    });

    constructor(opts = {}) {
        super();
        this.defineAllProperties();

        this.width = 400;
        this.height = 200;
        this.imageSet = [
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAKCAIAAADdHiL1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAVSURBVChTY/hfr04qGtUz3PTUqwMAkmQXomUBffUAAAAASUVORK5CYII=",
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAKCAIAAADdHiL1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAaSURBVChTY1Ta6MNAImCC0qSAUT2DWQ8DAwBbBgEzH5qZDQAAAABJRU5ErkJggg==",
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAKCAIAAADdHiL1AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAAaSURBVChTY2RY9IKBRMAEpUkBo3oGsx4GBgAy2QGeWbO0AwAAAABJRU5ErkJggg=="
        ];
        // this.text = "图片集合";

        for (var p in opts) {
            this[p] = opts[p];
        }
    }

    getType() {
        return "CarouselModel";
    }

    toStyle() {


        return {
            borderRadius: 0,
            padding: this.padding.toString(),
            ...super.getExtendStyle(),
        }
    }
}
